import React from 'react';
import { Stack } from '@mui/material';
import { AnalyticsBox } from 'components/AnalyticsBox/AnalyticsBox';
import { AnalyticsBarsBox } from 'components/AnalyticsBox/AnalyticsBarsBox';
import { EStatisticType } from 'views/Statistics/StatisticsView.types';
import { EMetric, BreakdownsResult } from 'api/useAnalytics';
import { AnalyticsTabProps } from './utils';
import { AnalyticsChartData } from './useAnalyticsChartData.hook';

interface AnalyticsBusinessTabProps extends AnalyticsTabProps {
  totalRevenueAnalytics: AnalyticsChartData;
}

const BREAKDOWNS_ANALYTICS: EMetric[] = [
  EMetric.DEPOSITS_PER_PRICE_POINT,
  EMetric.REVENUE_PER_PRICE_POINT
];

const AnalyticsBusinessTab: React.FC<AnalyticsBusinessTabProps> = ({
  dateRange,
  previousDateRange,
  totalRevenueAnalytics,
  xAxisDateFormat,
  isLoading,
  filteredAnalytics,
  formattedAnalytics,
  analytics,
  previousAnalytics
}) => (
  <Stack direction="column">
    <div className="flex flex-col gap-4">
      <AnalyticsBox
        key={EMetric.TOTAL_REVENUE}
        metricName={EMetric.TOTAL_REVENUE}
        stat={totalRevenueAnalytics?.stat}
        currentTrends={totalRevenueAnalytics?.currentTrends ?? []}
        previousTrends={totalRevenueAnalytics?.previousTrends}
        xAxisDateFormat={xAxisDateFormat}
        isLoading={isLoading}
      />
      <div className="grid grid-cols-3 gap-4">
        {filteredAnalytics.map((metricName) => {
          const item = formattedAnalytics[metricName];
          return (
            <AnalyticsBox
              key={metricName}
              metricName={metricName}
              stat={item?.stat}
              currentTrends={item?.currentTrends ?? []}
              previousTrends={item?.previousTrends}
              isLoading={isLoading}
              xAxisDateFormat={xAxisDateFormat}
            />
          );
        })}
        {BREAKDOWNS_ANALYTICS.map((metricName) => {
          const currentBreakdown = analytics.getBreakdowns.data?.find(
            (breakdown: BreakdownsResult) => breakdown.name === metricName
          );
          const previousBreakdown = previousAnalytics.getBreakdowns.data?.find(
            (breakdown: BreakdownsResult) => breakdown.name === metricName
          );
          return (
            <AnalyticsBarsBox
              isLoading={isLoading}
              metricName={metricName}
              currentBreakdown={
                currentBreakdown
                  ? currentBreakdown
                  : {
                      name: metricName,
                      type: EStatisticType.NUMBER,
                      values: []
                    }
              }
              comparedBreakdown={previousBreakdown}
              dateRange={dateRange}
              comparedDateRange={previousDateRange}
            />
          );
        })}
      </div>
    </div>
  </Stack>
);

export default AnalyticsBusinessTab;
